require('./src/css/global.scss');